import { type MouseEvent, useCallback, useState } from "react";

/**
 * Hook for managing menu anchor state and open/close handlers
 */
export const useMenuState = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return {
    anchorEl,
    isOpen: Boolean(anchorEl),
    handleOpen,
    handleClose,
  };
};
